import type { StudyDayGenericInput } from "api/generated";
import { getDayNameFromIndex } from "utils/calendarDateFormatting";

export const DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;
export const LOCAL_STORAGE_TIME_TO_LIVE = 1000 * 60 * 60 * 4; // 4 hrs, can/should change
export const ONE_WEEK_IN_MILLISECONDS = 1000 * 60 * 60 * 24 * 7;

export const TIMETABLE_REQUESTED_TIME = 120;
export const INTERVAL_TO_SHOW_ONBOARDING_TOOLTIP_BUTTON = 1000 * 2;

export const HANDSHAKE_QUERY_PARAM = "authorization-token";
export const ACCESS_TOKEN_PARAM = "todas-access-token";
export const PARENT_TOKEN_PARAM = "parent-token";
export const TEACHER_EVALUATION_TOKEN_PARAM = "teacher-evaluation-token";
export const VIMEO_STORAGE_KEY = "todas-video-progress";
export const EXAM_SETTINGS_KEY = "todas-exam-settings";
export const VIDEO_PROGRESS_RESET_THRESHOLD = 90;
export const VIDEO_INIT_TIME_RETURN_SECONDS = 2;
export const SEARCH_QUERY_PARAM = "q";
export const PAGE_QUERY_PARAM = "p";
export const SUBJECT_QUERY_PARAM = "s";
export const TAB_QUERY_PARAM = "tab";
export const SESSION_STORAGE_KEY = "todas-training-data";
export const TRAINING_TAB_KEY = "todas-training-tab";
export const BOOKS_INTRO_KEY = "todas-books-intro";
export const EXTERNAL_ID = "external_id";
export const USER_GRADE = "grade";

export const DATE_OF_FIRST_SCHOOL_DAY = "2023-09-04";
export const DATE_OF_ENTRANCE_EXAMINATION = "2025-04-14";

export const PHONE_VALIDATION_CODE_LENGTH = 6;
export const RESEND_CODE_TIMEOUT = 60;

export const DEFAULT_ASSIGNMENTS_COUNT = 3;
export const MAX_ASSIGNMENTS_PER_REQUEST = 30;

export const REWARDS_MONTH_TYPE = "month_plan";
export const REWARDS_POINTS_TYPE = "score";

export const ONBOARDING_STORE_ID = "onboarding";

export const DEFAULT_TIMETABLE_DURATION_MINUTES = 25;
export const DEFAULT_TIMETABLE_START = "17:00";
export const DEFAULT_GENERIC_TIMETABLE: StudyDayGenericInput[] = [
  {
    dayName: getDayNameFromIndex(1),
    duration: DEFAULT_TIMETABLE_DURATION_MINUTES,
    startAt: DEFAULT_TIMETABLE_START,
  },
  {
    dayName: getDayNameFromIndex(2),
    duration: DEFAULT_TIMETABLE_DURATION_MINUTES,
    startAt: DEFAULT_TIMETABLE_START,
  },
  {
    dayName: getDayNameFromIndex(3),
    duration: DEFAULT_TIMETABLE_DURATION_MINUTES,
    startAt: DEFAULT_TIMETABLE_START,
  },
  {
    dayName: getDayNameFromIndex(4),
    duration: DEFAULT_TIMETABLE_DURATION_MINUTES,
    startAt: DEFAULT_TIMETABLE_START,
  },
  {
    dayName: getDayNameFromIndex(5),
    duration: DEFAULT_TIMETABLE_DURATION_MINUTES,
    startAt: DEFAULT_TIMETABLE_START,
  },
  {
    dayName: getDayNameFromIndex(6),
    duration: DEFAULT_TIMETABLE_DURATION_MINUTES,
    startAt: DEFAULT_TIMETABLE_START,
  },
  {
    dayName: getDayNameFromIndex(7),
    duration: DEFAULT_TIMETABLE_DURATION_MINUTES,
    startAt: DEFAULT_TIMETABLE_START,
  },
];

// TODO: get slug from subjects
// AIDEV-NOTE: `path` musí končit slugem, jaký má předmět ve Firestore — stránka
// doučování ho páruje proti `subject.slug` z API. U AJ tu byl `anglicky-jazyk`,
// zatímco data mají `anglictina`, takže odkaz z menu vedl na trvale prázdnou
// obrazovku: nevykreslil se ani spinner, ani chybová hláška. Dokud se tenhle
// seznam nenahradí slugy z API (TODO výš), platí, že změna slugu v CMS se musí
// promítnout sem i do `usePageTitle`.
export const SUBJECT_LINKS: Record<string, { path: string; label: string }> = {
  M: { path: "/doucovani/matematika", label: "Matematika" },
  CJ: { path: "/doucovani/cesky-jazyk", label: "Český jazyk" },
  AJ: { path: "/doucovani/anglictina", label: "Anglický jazyk" },
} as const;

export const MOOD_ICONS = [
  { name: "🥺", value: 1 },
  { name: "😞", value: 2 },
  { name: "😐", value: 3 },
  { name: "😊", value: 4 },
  { name: "😁", value: 5 },
];

/**
 * Nabídka rychlostí přehrávání zvuku. Sdílená, aby zkoušení nanečisto a podcast
 * v detailu knihy nenabízely každý jinou sadu — dřív měly 0,5–2 a 1–2. [TD-312]
 */
export const PLAYBACK_RATES = [0.5, 1, 1.5, 2] as const;
